import { useMemo } from 'react'

import { PositionBalanceRow } from '~/components/smart-accounts/positions/PositionBalanceRow'
import { usePositionBalances } from '~/components/smart-accounts/positions/hooks/usePositionBalances'
import { useOrgSmartAccount } from '~/hooks/useSmartAccounts'
import { IAddress } from '~/types'

export const PositionBalances = ({ address }: { address: IAddress }) => {
  const { smartAccount } = useOrgSmartAccount(address)
  const { data: positionBalances } = usePositionBalances(
    smartAccount?.id,
    smartAccount?.orgId,
  )

  const displayedBalances = useMemo(() => {
    if (!positionBalances) {
      return []
    }

    return [...positionBalances].sort(
      (a, b) =>
        (b.feesUsdValue ?? b.usdValue ?? 0) -
        (a.feesUsdValue ?? a.usdValue ?? 0),
    )
  }, [positionBalances])

  const showPositionBalances =
    displayedBalances.length > 0 && smartAccount?.address

  if (!showPositionBalances) return null

  return (
    <div className="-mx-3 flex flex-col">
      {displayedBalances.map((balance) => (
        <PositionBalanceRow key={balance.id} balance={balance} />
      ))}
    </div>
  )
}
